// extracted by mini-css-extract-plugin
export default {"jump":"vYxIvnZ6J44ttD24Uupd","commentTableGroup":"lZC8__4iqRKkJe8dNbMc"};